module.exports = __webpack_public_path__ + "assets/img/kqyl_img.42deff16.png";